// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  platforme: 'DEMO',
  strapi_url: "https://strapi.hadeen-place.fr/",
  // sousDomaine: 'http://localhost:4200',
  sousDomaine: "https://demo.hadeen-place.fr",
  googleLog: "285698818452-lom8vnn7p5sjlf9hr86ci9fbhqat3sms.apps.googleusercontent.com",
  facebookLog: "3560711240655506",
  ws_url: "https://demo.hadeen-place.fr/api/v1/",
  socket_url: "https://demo.hadeen-place.fr/ws-hadeen",
  keys: "pk_test_51HTl4ZD1SZuRZVEhOuyy4QxEqVApakNf5rg4wCUdXCsV9L506xQcziPCyEiiL9yUCZwSyg0M1RCzDHjlL8zZSBFj00YCXIHlKj",
  gtag_key: "UA-180350306-2",
  // apiUrlSmodin: 'https://rewriter-paraphraser-text-changer-multi-language.p.rapidapi.com/rewrite',
  // apiKeySmodin: 'e43a5f997cmsh9496dc57be2348bp18e0a7jsn7fea13ea2d0f',
  // apiHostSmodin: 'rewriter-paraphraser-text-changer-multi-language.p.rapidapi.com',
  service_format: (width, height, url) => `https://service-pic.vatilab.com/unsafe/fit-in/${width}x${height}/filters:format(webp)/${url}`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
